import axios from 'axios';
import _ from 'lodash';
import { saveCredentials } from '../features/authentication/actions';

const getContentDisposition = (headers) => {
  const contentDisposition = headers['content-disposition'];
  return _.split(contentDisposition, ';');
};

const extractFilename = (contentDispositionArray) => {
  const filenameItem = contentDispositionArray.find((x) => {
    return x.includes('filename=');
  });

  let filename = _.trim(_.split(filenameItem, 'filename=')[1], '" ');
  if (!filename) {
    filename = 'undefined_filename';
  }

  return filename;
};

const getFilename = (headers) => {
  const contentDisposition = getContentDisposition(headers);
  const filename = extractFilename(contentDisposition);
  return decodeURIComponent(filename);
};

const buildingFile = (data, filename) => {
  const downloadUrl = window.URL.createObjectURL(new Blob([data]));
  const link = document.createElement('a');
  link.href = downloadUrl;
  link.setAttribute('download', decodeURIComponent(filename));
  document.body.appendChild(link);
  link.click();
  link.remove();
};

export const updatingCredentials = (headers) => {
  const credentialsProperties = ['access-token', 'uid', 'expiry', 'client', 'token-type'];
  const newCreds = {};
  credentialsProperties.forEach((field) => {
    newCreds[field] = headers[field];
  });

  if (newCreds.expiry && newCreds['access-token']) {
    localStorage.setItem('credentials', JSON.stringify(newCreds));
    saveCredentials(newCreds);
  }
};

export const downloadingFileAndUpdatingCredentials = async (url) => {
  axios.request({
    url, method: 'GET', responseType: 'blob', /* NOTE: Must be blob or .pdf downloads break */
  }).then((response) => {
    const { data, headers } = response;
    const filename = getFilename(headers);
    buildingFile(data, filename);
    updatingCredentials(headers);
  });
};
